import React from 'react';
import Parent from './Parent';
import { OrgChart, OrgChartUser } from '../../types';
import { getActive } from './data';

interface ParentsProps {
  active: string;
  value: OrgChart;
  onClick: (id: string) => void;
}

interface ParentUser extends OrgChartUser {
  id: string;
  reports: string[];
  manager: string | undefined;
}

export default function Parents({ active, value, onClick }: ParentsProps) {
  const current = getActive(active, value);

  const parents = React.useMemo(() => {
    const p: ParentUser[] = [];
    let next = getActive(current.manager, value);

    while (next) {
      const nextId = next.manager;
      p.push({ id: current.manager, ...next });
      next = getActive(nextId, value);
    }

    return p.reverse();
  }, [current, value]);

  return parents.map((p) => (
    <Parent key={p.id} user={p} onClick={onClick} />
  ));
}
